import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { BonusTitle } from '@atlas/components';
import { NotificationManager } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const BonusActivationSuccessPopup = props => {
  const {
    data: { bonus, bonusName, bonusNameHighlighted },
    id,
  } = props;
  const title = bonusName ?? bonus;

  const onCloseHandler = useCallback(() => NotificationManager.removeNotification(id), [id]);

  return (
    <div className="bonus-activation-toast">
      <Icon className="bonus-activation-toast__icon" name="success-bold" />

      <div className="bonus-activation-toast__wrapper">
        <p className="bonus-activation-toast__title">
          <BonusTitle name={title} nameHighlighted={bonusNameHighlighted} />
        </p>
        <Label
          className="bonus-activation-toast__subtitle"
          message="bonus_successfully_activated"
        />
      </div>

      <Icon className="bonus-activation-toast__close" name="close" onClick={onCloseHandler} />
      <div className="bonus-activation-toast__timer" />
    </div>
  );
};

BonusActivationSuccessPopup.propTypes = {
  data: PropTypes.shape({
    bonus: PropTypes.string,
    bonusName: PropTypes.string,
    bonusNameHighlighted: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BonusActivationSuccessPopup;
